import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ProfileInput, ProfileUpdateInput, ProfileOutput } from './models/profile.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private apiUrl = `${environment.apiUrl}/profile`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ProfileOutput[]> {
    return this.http.get<ProfileOutput[]>(this.apiUrl, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao buscar perfis.');
        }
        return response.body || [];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  getById(id: string): Observable<ProfileOutput> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<ProfileOutput>(url, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao buscar perfil.');
        }
        return response.body!;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  create(profile: ProfileInput): Observable<ProfileOutput> {
    return this.http.post<ProfileOutput>(this.apiUrl, profile, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 201) {
          throw new Error('Erro ao criar perfil.');
        }
        return response.body!;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  update(id: string, profile: ProfileUpdateInput): Observable<ProfileOutput> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.put<ProfileOutput>(url, profile, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao atualizar perfil.');
        }
        return response.body!;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  delete(id: string): Observable<void> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.delete(url, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 204) {
          throw new Error('Erro ao deletar perfil.');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}
